// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay--overlay--18cLx","openOverlay":"Overlay--openOverlay--BQSOX","overlayBox":"Overlay--overlayBox--Ojh-g","closeButton":"Overlay--closeButton--3UHqk"};